











import { Contractors } from "@timesheets/routes-api-common";
import { getSummaryRoleComponentSelectorMixin } from "Components/Summary/SummaryRoleComponentSelector/getSummaryRoleComponentSelectorMixin";
import { ISummaryVue } from "@/components/Summary/mixins/ISummaryVue";
import { IContractorsSummaryFilter } from "./Summary/IContractorsSummaryFilter";
import { IRowMeta } from "@/components/Summary/Row/mixins/IRowMeta";
import { IResolvedPermissions } from "@/components/Summary/IResolvedPermissions";
import { ISummaryRowEntity } from "@/components/Summary/Row/mixins/ISummaryRowEntity";
import { Contractors as ContractorsApp } from "@timesheets/routes-app";

const base = getSummaryRoleComponentSelectorMixin(Contractors.All);

export default base.extend({
  name: "ContractorsSummaryRoleComponentSelector",

  components: {
    Context_RecruitmentAgencyAdministrationRole: () => import("./Summary/RecruitmentAgencyAdministrationRole/Context/Index.vue"),
    RootMenu_RecruitmentAgencyAdministrationRole: () => import("./Summary/RecruitmentAgencyAdministrationRole/RootMenu/Index.vue"),
    // ContractingRole: () => import("./Summary/ContractingRole/Index.vue"),
    AuthorisingRole: () => import("./Summary/AuthorisingRole/Index.vue"),
  },

  computed: {
    contractorComponent(this: ISummaryVue<ISummaryRowEntity, IContractorsSummaryFilter, IRowMeta, IResolvedPermissions>): string {
      if (this.isRecruitmentAgencyAdministrationRole) {
        const isRootMenu = this.$router.currentRoute.path.startsWith(ContractorsApp.Root);
        if (isRootMenu) {
          return "RootMenu_RecruitmentAgencyAdministrationRole";
        } else {
          return "Context_RecruitmentAgencyAdministrationRole";
        }
      } else if (this.isAuthorisingRole) {
        return "AuthorisingRole";
      } else {
        return "";
      }
    },
  },
});
